import { Suspense, useEffect, useMemo } from 'react';
import * as ReactDOMClient from "react-dom/client";
import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";
import { isTouchDevice, ITDProvider, ITDRouterAdapter, Spin } from '@inntechcorp/it-design';
import lazy from "@loadable/component";
import Cookies from 'js-cookie';

import { BackOfficeProvider } from 'Context/BackOfficeContext';

import { DefaultSpinner, LoadingDefaultHeight, SpinWrapper } from "Styles/global.styled";

import './dayjs-setup';

import "@inntechcorp/it-design/dist/global.css";

import 'Styles/global.scss';




const App = lazy(() => import("Pages/app"));

/**
 * itd 4.x router'sız gelir (routing seam): adapter verilmezse SQ.set URL'i
 * raw pushState ile yazar ve react-router'ın useLocation'ı bunu GÖRMEZ —
 * CoreDataTable gibi [location.search]'e bağlı her şey sağır kalır (tablo
 * aramada yenilenmiyordu). Adapter itd'nin URL okuma/yazmasını app
 * router'ından geçirir; seam dokümanı gereği navigation'da re-render olan
 * bir component içinde kurulur.
 */
const AppProviders = () => {

  const location = useLocation();
  const navigate = useNavigate();

  /* .itd-mobile cihaz bayrağı: mobileFullscreen modal gibi mobil kalıplar
     bu sınıfla açılır (user-hub'ın kendi dokümanına bastığı bayrağın aynısı;
     panelde DS'in UA-tabanlı touch tespiti kullanılır, viewport değil). */
  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('itd-mobile', isTouchDevice());
    return () => root.classList.remove('itd-mobile');
  }, []);

  const router = useMemo<ITDRouterAdapter>(() => ({
    location,
    navigate: (to, options) => navigate(to, { replace: options?.replace, state: options?.state }),
  }), [location, navigate]);

  return (
    <ITDProvider
      theme          = {Cookies.get("aff-theme") || "light"}
      primaryBase    = "oklch(0.62 0.18 250)" /* light's blue on BOTH themes (default dark primary is gold) */
      customTheme    = {{ fontSans: "'Inter', system-ui, -apple-system, sans-serif" }}
      defaultVariant = "filled" /* panel geneli: form kontrolleri + Card filled; explicit variant her zaman kazanır */
      router         = {router}
    >
      <BackOfficeProvider>
        <App />
      </BackOfficeProvider>
    </ITDProvider>
  );

}

function renderDOM() {

  const rootElement = document.getElementById("inn-tech");
  const root        = rootElement && ReactDOMClient.createRoot(rootElement);

  const suspense = (
    <LoadingDefaultHeight $minHeight="100vh">
      <DefaultSpinner>
        <SpinWrapper>
          <Spin />
        </SpinWrapper>
      </DefaultSpinner>
    </LoadingDefaultHeight>
  );

  return (

    root?.render(

      <Suspense fallback={suspense}>

        <BrowserRouter>
          <AppProviders />
        </BrowserRouter>

      </Suspense>

    )

  )

}

renderDOM();
